<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      :gradient="sidebarOverlayGradiant"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="logo"
              height="34"
              contain
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{systemName}}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-if="responsive"
        >
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          v-if="link.roles.includes(userRole)"
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: './img/vuetifylogo.png',
    userRole:sessionStorage.getItem('role'),
    systemName: sessionStorage.getItem('role') == 'admin'?'管理员':"校区代理",
    links: [
      {
        to: '/dashboard',
        icon: 'mdi-view-dashboard',
        text: '数据总览',
        roles:['admin','user']
      },
      {
        to: '/order',
        icon: 'el-icon-s-order',
        text: '订单管理',
        roles:['admin','user']
      },
      {
        to: '/dl',
        icon: 'el-icon-connection',
        text: '代理管理',
        roles:['admin']
      },
      {
        to: '/merchantlist',
        icon: 'mdi-account',
        text: '商家管理',
        roles:['admin','user']
      },
      {
        to: '/cash',
        icon: 'el-icon-s-marketing',
        text: '提现管理',
        roles:['admin','user']
      },
      {
        to: '/CanTing',
        icon: 'el-icon-reading',
        text: '餐厅提现',
        roles:['admin']
      },
      {
        to: '/history',
        icon: 'el-icon-paperclip',
        text: '入账明细',
        roles:['admin','user']
      },
      {
        to: '/setting',
        icon: 'el-icon-s-tools',
        text: '系统设置',
        roles:['admin']
      },


      // {
      //   to: '/user',
      //   icon: 'mdi-account',
      //   text: '用户管理'
      // },
      // {
      //   to: '/agent',
      //   icon: 'el-icon-s-shop',
      //   text: '城市代理'
      // },
      // {
      //   to: '/verify',
      //   icon: 'el-icon-s-check',
      //   text: '审核管理'
      // },
      
      // {
      //   to: '/order',
      //   icon: 'el-icon-s-order',
      //   text: '订单管理'
      // },
      // {
      //   to: '/anlysis',
      //   icon: 'el-icon-s-marketing',
      //   text: '数据报表'
      // },
      // {
      //   to: '/admin',
      //   icon: 'mdi-account-switch',
      //   text: '系统用户及权限'
      // },
      // {
      //   to: '/text',
      //   icon: 'el-icon-reading',
      //   text: '文本信息'
      // },
      // {
      //   to: '/config',
      //   icon: 'el-icon-s-tools',
      //   text: '系统设置'
      // },
      // {
      //   to: '/wxappset',
      //   icon: 'el-icon-paperclip',
      //   text: '小程序设置'
      // },
      // {
      //   to: '/opentp',
      //   icon: 'el-icon-connection',
      //   text: '第三方应用'
      // }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant () {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: -5px !important;
      padding-left: 0px;
      padding-right: -10px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }
  }
</style>
